import { useAtom, useSetAtom } from "jotai";
import { Category, Product } from "@/shared/utils/interfaces";
import { atomWithImmer } from "jotai-immer";

interface PosOrderMenuValuesProps {
  selectedCat: Category;
  selectedTab: number;
}

export const defaultPosOrderMenuValues: PosOrderMenuValuesProps = {
  selectedTab: 0,
  selectedCat: null,
};

export const posOrderMenuValuesAtom = atomWithImmer(defaultPosOrderMenuValues);

const usePosOrderMenuValues = () => {
  const atom = useAtom(posOrderMenuValuesAtom);
  return atom;
};

export const useSetPosOrderMenuValues = () =>
  useSetAtom(posOrderMenuValuesAtom);

export default usePosOrderMenuValues;
